var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:({width: (_vm.remainingTimePercentage + "%")})})]),_c('div',{staticClass:"level"},[_vm._v("Level "+_vm._s(_vm.level))])])}
var staticRenderFns = []

export { render, staticRenderFns }